import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RegistrationPinsPermissionQuery } from '../../queries/registration_pins_permission_query';
import { RegistrationPinsPermissionFacade } from '../../facades/registration_pins_permission_facade';
import { PayTuitionQuery } from '../../queries/pay_tuition_query';

class RegistrationControls {
  private termId: number;
  private showControls: boolean = false;
  private preRegistrationCheckMessage: string = '';
  private showPayTuition: boolean = false;
  private registrationPreCheckSuccessBound: () => void;
  private registrationPreCheckFailBound: () => void;
  private hideRegistrationControlsOnMobile: boolean = false;
  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngRegistrationPinsPermissionQuery: RegistrationPinsPermissionQuery,
    private ngRegistrationPinsPermissionFacade: RegistrationPinsPermissionFacade,
    private ngPayTuitionQuery: PayTuitionQuery
  ) {}
  $onInit() {
    this.showControls = true;
    this.showPayTuition = this.ngPayTuitionQuery.result.showPayTuition;
    this.registrationPreCheckFailBound = this.registrationPreCheckFail.bind(this);
    this.registrationPreCheckSuccessBound = this.registrationPreCheckSuccess.bind(this);
    this.ngComponentCommunicatorService.subscribe('REGISRATION_PRE_CHECK_FAIL', this.registrationPreCheckFailBound);
    this.ngComponentCommunicatorService.subscribe(
      'REGISRATION_PRE_CHECK_SUCCESS',
      this.registrationPreCheckSuccessBound
    );
  }

  registrationPreCheckFail() {
    this.toggleControls(true);
  }
  registrationPreCheckSuccess() {
    this.toggleControls(false);
  }
  toggleControls(flag: boolean) {
    this.showControls = !flag;
  }
}

class RegistrationControlsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      termId: '<'
    };
    this.controller = RegistrationControls;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_controls/registration_controls.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationControls', new RegistrationControlsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_controls/registration_controls.ts